import http from '../axios';

export function index(filters) {
  return http.get('/vessel_voyages', {
    params: filters
  });
}